// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ocade-button {
  position: relative;
  display: inline-block;
	padding: .7rem;
	text-decoration: none;
	font-size: 14px;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  border: none;
  border-left: 5px solid transparent;
	border-radius: 4px;
  overflow: hidden;
	cursor: pointer;
}

.ocade-button:hover {
  opacity: .95;
}

.ocade-button:focus {
  outline: none;
  outline: 4px outset var(--color-blanc);
}

.ocade-button.design-default,
.ocade-button.design-info,
.ocade-button.design-success,
.ocade-button.design-warn,
.ocade-button.design-error {
  color: var(--color-blanc);
}

.ocade-button.design-default {
  background-color: rgba(255,255,255,.6);
  color: var(--color-noir);
}

.ocade-button.design-default:hover {
  background-color: rgba(255,255,255,.8);
  border-left: 5px solid rgba(255,255,255,.6);
}

.ocade-button.design-info {
  background-color: var(--info-fonce);
  font-weight: 500;
}

.ocade-button.design-info:hover {
  background-color: var(--info-clair);
  border-left: 5px solid var(--info-fonce);
}

.ocade-button.design-info:focus {
  outline-color: var(--info-fonce);
}

.ocade-button.design-success {
  background-color: var(--success-fonce);
}

.ocade-button.design-success:hover {
  background-color: var(--success-clair);
  border-left: 5px solid var(--success-fonce);
}

.ocade-button.design-success:focus {
  outline-color: var(--success-fonce);
}

.ocade-button.design-warn {
  background-color: var(--warn-fonce);
}

.ocade-button.design-warn:hover {
  background-color: var(--warn-clair);
  border-left: 5px solid var(--warn-fonce);
}

.ocade-button.design-warn:focus {
  outline-color: var(--warn-fonce);
}

.ocade-button.design-error {
  background-color: var(--error-fonce);
  color: var(--color-blanc);
}

.ocade-button.design-error:hover {
  background-color: var(--error-clair);
  border-left: 5px solid var(--error-fonce);
}

.ocade-button.design-error:focus {
  outline-color: var(--error-fonce);
}

.ocade-button.has-background-image {
  position: relative;
  display: flex;
  align-items: center;
}

.ocade-button.has-background-image::before {
  content: "";
  position: relative;
  display: inline-block;
  width: var(--size);
  height: var(--size);
  margin-right: .3rem;
  background-color: var(--background-color-icon);
  mask-image: var(--background-image-url);
  mask-repeat: no-repeat;
  mask-size: var(--size);
  mask-position: left center;
}

.ocade-button.has-background-image:hover::before {
  background-color: var(--background-color-icon-hover);
}

.ocade-button.is-active::after {
  content: "";
  position: absolute;
  right: -12px;
  top: -12px;
  width: 1.4rem;
  height: 1.4rem;
  background-color: var(--color-blanc);
  transform: rotate(45deg);
  z-index: 0;
}

.ocade-button a {
  text-decoration: none;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/composants/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;CACtB,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,gIAAgI;EAC/H,YAAY;EACZ,kCAAkC;CACnC,kBAAkB;EACjB,gBAAgB;CACjB,eAAe;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,uCAAuC;EACvC,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".ocade-button {\n  position: relative;\n  display: inline-block;\n\tpadding: .7rem;\n\ttext-decoration: none;\n\tfont-size: 14px;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  border: none;\n  border-left: 5px solid transparent;\n\tborder-radius: 4px;\n  overflow: hidden;\n\tcursor: pointer;\n}\n\n.ocade-button:hover {\n  opacity: .95;\n}\n\n.ocade-button:focus {\n  outline: none;\n  outline: 4px outset var(--color-blanc);\n}\n\n.ocade-button.design-default,\n.ocade-button.design-info,\n.ocade-button.design-success,\n.ocade-button.design-warn,\n.ocade-button.design-error {\n  color: var(--color-blanc);\n}\n\n.ocade-button.design-default {\n  background-color: rgba(255,255,255,.6);\n  color: var(--color-noir);\n}\n\n.ocade-button.design-default:hover {\n  background-color: rgba(255,255,255,.8);\n  border-left: 5px solid rgba(255,255,255,.6);\n}\n\n.ocade-button.design-info {\n  background-color: var(--info-fonce);\n  font-weight: 500;\n}\n\n.ocade-button.design-info:hover {\n  background-color: var(--info-clair);\n  border-left: 5px solid var(--info-fonce);\n}\n\n.ocade-button.design-info:focus {\n  outline-color: var(--info-fonce);\n}\n\n.ocade-button.design-success {\n  background-color: var(--success-fonce);\n}\n\n.ocade-button.design-success:hover {\n  background-color: var(--success-clair);\n  border-left: 5px solid var(--success-fonce);\n}\n\n.ocade-button.design-success:focus {\n  outline-color: var(--success-fonce);\n}\n\n.ocade-button.design-warn {\n  background-color: var(--warn-fonce);\n}\n\n.ocade-button.design-warn:hover {\n  background-color: var(--warn-clair);\n  border-left: 5px solid var(--warn-fonce);\n}\n\n.ocade-button.design-warn:focus {\n  outline-color: var(--warn-fonce);\n}\n\n.ocade-button.design-error {\n  background-color: var(--error-fonce);\n  color: var(--color-blanc);\n}\n\n.ocade-button.design-error:hover {\n  background-color: var(--error-clair);\n  border-left: 5px solid var(--error-fonce);\n}\n\n.ocade-button.design-error:focus {\n  outline-color: var(--error-fonce);\n}\n\n.ocade-button.has-background-image {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ocade-button.has-background-image::before {\n  content: \"\";\n  position: relative;\n  display: inline-block;\n  width: var(--size);\n  height: var(--size);\n  margin-right: .3rem;\n  background-color: var(--background-color-icon);\n  mask-image: var(--background-image-url);\n  mask-repeat: no-repeat;\n  mask-size: var(--size);\n  mask-position: left center;\n}\n\n.ocade-button.has-background-image:hover::before {\n  background-color: var(--background-color-icon-hover);\n}\n\n.ocade-button.is-active::after {\n  content: \"\";\n  position: absolute;\n  right: -12px;\n  top: -12px;\n  width: 1.4rem;\n  height: 1.4rem;\n  background-color: var(--color-blanc);\n  transform: rotate(45deg);\n  z-index: 0;\n}\n\n.ocade-button a {\n  text-decoration: none;\n  color: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
